import InvoiceReport from '../../invoice/InvoiceReport';
import MoveReport from '../../movement/MoveReport';
import SupplyReport from '../../supply/SupplyReport';
import ConversionReport from '../../conversion/ConversionReport';
import ProductionReport from '../../production/ProductionReport';
import BomReport from '../../production/BomReport';
import WalletClientModal from '../../wallet/WalletClientModal';
import ExpenseReport from '../../expense/ExpenseReport';
import VoucherReport from '../../voucher/VoucherReport';
import VoucherBatchReport from '../../voucher/VoucherBatchReport';
import DepositReport from '../../deposit/Report';
import { isVoucherBatchReport, type RecentReportKind } from '../recentTransactionReport';

export type RecentReportView = {
  kind: RecentReportKind;
  bundle: any;
};

type RecentTransactionReportsProps = {
  reportView: RecentReportView | null;
  onClose: () => void;
};

const RecentTransactionReports = ({ reportView, onClose }: RecentTransactionReportsProps) => (
  <>
    {reportView?.kind === 'sale' && (
      <InvoiceReport isOpen toggle={onClose} bundle={reportView.bundle} />
    )}
    {reportView?.kind === 'movement' && (
      <MoveReport isOpen toggle={onClose} bundle={reportView.bundle} />
    )}
    {reportView?.kind === 'supply' && (
      <SupplyReport isOpen toggle={onClose} bundle={reportView.bundle} />
    )}
    {reportView?.kind === 'conversion' && (
      <ConversionReport isOpen toggle={onClose} bundle={reportView.bundle} />
    )}
    {reportView?.kind === 'production' && (
      <ProductionReport isOpen toggle={onClose} bundle={reportView.bundle} />
    )}
    {reportView?.kind === 'bom' && (
      <BomReport isOpen toggle={onClose} bundle={reportView.bundle} />
    )}
    {reportView?.kind === 'wallet' && Number(reportView.bundle.client_id || reportView.bundle.batch || 0) > 0 && (
      <WalletClientModal
        isOpen
        wallet={{
          client_id: Number(reportView.bundle.client_id || reportView.bundle.batch),
          client: String(reportView.bundle.client || reportView.bundle.clientName || reportView.bundle.description || ''),
          balance: 0,
          is_active: true,
        }}
        onClose={onClose}
      />
    )}
    {reportView?.kind === 'expense' && Number(reportView.bundle.id || 0) > 0 && (
      <ExpenseReport
        isOpen
        toggle={onClose}
        bundle={{
          id: Number(reportView.bundle.id),
          date: String(reportView.bundle.date || ''),
          amount: Number(reportView.bundle.amount || 0),
          mode: Number(reportView.bundle.mode || 0),
          mode_name: String(reportView.bundle.mode_name || ''),
          depot: reportView.bundle.depotId ?? null,
          depot_name: reportView.bundle.depot_name || reportView.bundle.depot || '',
          category: String(reportView.bundle.category || ''),
          payee: String(reportView.bundle.payee || ''),
          batch: reportView.bundle.batch || '',
          number: String(reportView.bundle.number || reportView.bundle.reference || reportView.bundle.ref || ''),
          description: reportView.bundle.description || '',
        }}
      />
    )}
    {reportView?.kind === 'voucher' && isVoucherBatchReport(reportView.bundle) && (
      <VoucherBatchReport
        isOpen
        toggle={onClose}
        batch={String(reportView.bundle.batch)}
      />
    )}
    {reportView?.kind === 'voucher'
      && !isVoucherBatchReport(reportView.bundle)
      && Number(reportView.bundle.id || 0) > 0 && (
      <VoucherReport
        isOpen
        toggle={onClose}
        bundle={{
          id: Number(reportView.bundle.id),
          code: String(reportView.bundle.code || reportView.bundle.reference || ''),
          amount: Number(reportView.bundle.amount || 0),
          batch: reportView.bundle.batch || '',
          type: reportView.bundle.voucher_type || reportView.bundle.type,
          status: reportView.bundle.status || 'ACTIVE',
        } as any}
      />
    )}
    {reportView?.kind === 'deposit' && Boolean(reportView.bundle.batch || reportView.bundle.reference) && (
      <DepositReport
        isOpen
        toggle={onClose}
        bundle={{ batch: reportView.bundle.batch || reportView.bundle.reference }}
      />
    )}
  </>
);

export default RecentTransactionReports;
